import { render, staticRenderFns } from "./ColumnViewPage.vue?vue&type=template&id=0f37552f&scoped=true&"
import script from "./ColumnViewPage.vue?vue&type=script&lang=js&"
export * from "./ColumnViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f37552f",
  null
  
)

export default component.exports